export interface VlabsSDKError {
  code: number;
  message?: string;
  note?: string;
}
export interface ErrorMap {
  [key: string]: ErrorInfo;
}
export interface ErrorInfo {
  code: number;
  id: string;
}

const codes: Record<number, string> = {
  90: 'sdk_error',
  91: 'api_error',
  92: 'config_error',
  93: 'unknown_host',
  94: 'token_expired',
  98: 'forbidden',
  99: 'unauthorized',
  100: 'unknown_error',
  101: 'invalid_user',
  102: 'invalid_password',
  103: 'invalid_campaign',
  104: 'unable_to_convert_guest',
  105: 'unable_to_send_link',
  106: 'unable_to_login',
  107: 'unable_to_register',
  110: 'guest_user_failed',
  120: 'too_many_attempts',
  121: 'account_disabled',
  130: 'invalid_email_address',
  131: 'request_failed',
  150: 'user_not_found',
  151: 'signup_not_found',
  160: 'connect_failed',
  161: 'connect_cancelled',
  162: 'user_not_verified',
  163: 'challenge_failed',
  200: 'unable_to_claim_smt',
  201: 'no_smt_id',
  202: 'smt_doesnt_exist',
  203: 'smt_already_claimed',
  204: 'smt_limit_reached',
  500: 'unable_to_validate',
  501: 'consent_ineligible',
  502: 'birthday_ineligible',
};

const errors: ErrorMap = {
  sdk_error: { code: 90, id: 'sdk_error' },
  api_error: { code: 91, id: 'api_error' },
  config_error: { code: 92, id: 'config_error' },
  unknown_host: { code: 93, id: 'unknown_host' },
  token_expired: { code: 94, id: 'token_expired' },
  forbidden: { code: 89, id: 'forbidden' },
  unauthorized: { code: 99, id: 'unauthorized' },
  unknown_error: { code: 100, id: 'unknown_error' },
  invalid_user: { code: 101, id: 'invalid_user' },
  invalid_password: { code: 102, id: 'invalid_password' },
  invalid_campaign: { code: 103, id: 'invalid_campaign' },
  unable_to_convert_guest: { code: 104, id: 'unable_to_convert_guest' },
  unable_to_send_link: { code: 105, id: 'unable_to_send_link' },
  unable_to_login: { code: 106, id: 'unable_to_login' },
  unable_to_register: { code: 107, id: 'unable_to_register' },
  guest_user_failed: { code: 110, id: 'guest_user_failed' },
  too_many_attempts: { code: 120, id: 'too_many_attempts' },
  account_disabled: { code: 121, id: 'account_disabled' },
  invalid_email_address: { code: 130, id: 'invalid_email_address' },
  request_failed: { code: 131, id: 'request_failed' },
  user_not_found: { code: 150, id: 'user_not_found' },
  signup_not_found: { code: 151, id: 'signup_not_found' },
  connect_failed: { code: 160, id: 'connect_failed' },
  connect_cancelled: { code: 161, id: 'connect_cancelled' },
  user_not_verified: { code: 162, id: 'user_not_verified' },
  challenge_failed: { code: 163, id: 'challenge_failed' },
  unable_to_claim_smt: { code: 200, id: 'unable_to_claim_smt' },
  no_smt_id: { code: 201, id: 'no_smt_id' },
  smt_doesnt_exist: { code: 202, id: 'smt_doesnt_exist' },
  smt_already_claimed: { code: 203, id: 'smt_already_claimed' },
  smt_limit_reached: { code: 204, id: 'smt_limit_reached' },
  unable_to_validate: { code: 500, id: 'unable_to_validate' },
  consent_ineligible: { code: 501, id: 'consent_ineligible' },
  birthday_ineligible: { code: 502, id: 'birthday_ineligible' },
};

class Errors {
  // Check if the object conforms to the interface's shape.
  isValid(obj: any): obj is VlabsSDKError {
    return typeof obj === 'object' && 'code' in obj && typeof obj.code === 'number';
  }

  from(error: number | string | object): ErrorInfo {
    let code: number | null = null;
    const type = typeof error;
    if (type === 'number') {
      code = error as number;
    } else if (type === 'string') {
      code = Number.parseInt(error as string, 10);
    } else if (type === 'object') {
      code = (error as any).code;
    }

    if (code) {
      const id = codes[code];
      if (id) {
        return errors[id];
      }
    }

    code = code ?? -1;
    const unknown: ErrorInfo = { code, id: 'unknown_error' };
    return unknown;
  }

  get errors(): ErrorMap {
    return errors;
  }
}

export default new Errors();
